import { Typography, Link, Stack } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useRootStore } from '../../../../stores/rootStore';
import { CountryOfBirthMetrics } from './CountryOfBirthMetrics';
import { EducationMetrics } from './EducationMetrics';
import { EmploymentAndOccupationMetrics } from './EmploymentAndOccupationMetrics';
import { HouseholdMetrics } from './HouseholdMetrics';
import { PopulationMetrics } from './PopulationMetrics';
import { ReligionMetrics } from './ReligionMetrics';
import { SuburbInformationMetrics } from './SuburbInformationMetrics';

export const MetricTypesCensus = () => {
  const country = useRootStore(state => state.country);

  return (
    <>
      <Typography
        id="metric-types-census"
        variant="h5"
        fontWeight={600}
        my={0.5}
      >
        Census
      </Typography>

      <Typography variant="body2">
        Our census data is available via our{' '}
        <Link
          component={RouterLink}
          to={`/apis/cotality-apis/market-insights-${country}#/census`}
        >
          Census Statistics
        </Link>{' '}
        and{' '}
        <Link
          component={RouterLink}
          to={`/apis/cotality-apis/market-insights-${country}#/charts`}
        >
          Charts
        </Link>{' '}
        services. The Census metrics available contain census data as gathered
        by the Australian Bureau of Statistics (ABS) and Statistics New Zealand.
      </Typography>

      <ul>
        <li>
          <Link href="#country-of-birth-metrics">Country of Birth</Link>
        </li>
        <li>
          <Link href="#education-metrics">Education</Link>
        </li>
        <li>
          <Link href="#employment-and-occupation-metrics">
            Employment & Occupation
          </Link>
        </li>
        <li>
          <Link href="#household-metrics">Household</Link>
        </li>
        <li>
          <Link href="#population-metrics">Population</Link>
        </li>
        <li>
          <Link href="#religion-metrics">Religion</Link>
        </li>
        <li>
          <Link href="#suburb-information-metrics">Suburb Information</Link>
        </li>
      </ul>

      <br />

      <Stack gap={6}>
        <CountryOfBirthMetrics />
        <EducationMetrics />
        <EmploymentAndOccupationMetrics />
        <HouseholdMetrics />
        <PopulationMetrics />
        <ReligionMetrics />
        <SuburbInformationMetrics />
      </Stack>
    </>
  );
};
